<div style="padding:24px 32px 0">
    <app-host-group-base-info [item]="data"></app-host-group-base-info>
    <app-base-performace-chart [id]="data.actionParams" [performance]="[22,21,370]" type="HOST_GROUP_TYPE" *ngIf="!FeatureConfig.IsHidePms"></app-base-performace-chart>
    <app-host-group-resource [data]="data"></app-host-group-resource>
</div>
